import React from 'react';

export const name = 'flag-IE';

export const FlagIE = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_235)">
      <mask
        id="mask0_2_235"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_235)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M24 12C23.9997 9.54989 23.2494 7.15861 21.85 5.14748C20.4506 3.13636 18.4691 1.60179 16.1719 0.75V23.25C18.4691 22.3982 20.4506 20.8636 21.85 18.8525C23.2494 16.8414 23.9997 14.4501 24 12Z"
          fill="#FF9811"
        />
        <path
          d="M0 12C0.000299071 14.4501 0.750567 16.8414 2.14997 18.8525C3.54938 20.8636 5.53088 22.3982 7.82812 23.25V0.75C5.53088 1.60179 3.54938 3.13636 2.14997 5.14748C0.750567 7.15861 0.000299071 9.54989 0 12Z"
          fill="#6DA544"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_235">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
